import gsap from 'gsap';

export default class LoadingScreen {
    el = null;
    stateController = null;
    mapResources = null;
    startBtnEl = null;
    audioNoticeEl = null;
    enableSoundBtnEl = null;
    introEl = null;

    constructor(el, stateController, mapResources) {
        this.el = el;
        this.stateController = stateController;
        this.mapResources = mapResources;
        this.startBtnEl = this.el.querySelector('.jsStartBtn');
        this.audioNoticeEl = this.el.querySelector('.jsAudioNotice');
        this.enableSoundBtnEl = this.el.querySelector('.jsEnableSoundBtn');
        this.introEl = this.el.querySelector('.jsIntro');

        this.addEventListeners();
    }

    addEventListeners() {
        this.enableSoundBtnEl.addEventListener('click', e => {
            e.preventDefault();

            // TODO: To enable the sound (and get the user's permission) play a sound over here

            this.goToIntro();
        });

        this.startBtnEl.addEventListener('click', e => {
            e.preventDefault();
            scrollWheelEnabled = false;
            this.stateController.start();
        });

        this.mapResources.on('ready', () => {
            gsap.timeline()
                .set(this.startBtnEl, { display: 'block', opacity: 0 })
                .to(this.startBtnEl, { duration: 0.5, opacity: 1, ease: 'power2.inOut' })
            ;
        });
    }

    goToIntro() {
        const els = this.el.querySelectorAll('.jsTitle, .jsSubtitle, .jsIntroText, .jsText, .jsBtnWrapper');

        gsap.timeline()
            .add(() => this.introEl.classList.add('show'))
            .set(this.introEl, { opacity: 0 })
            .set(els, { opacity: 0, y: 50 })

            .to(this.audioNoticeEl, { duration: 0.5, opacity: 0, ease: 'power2.inOut' })
            .to(this.introEl, { duration: 0.5, opacity: 1, ease: 'power2.inOut' }, '-=0.5')
            .to(els, { duration: 2, opacity: 1, y: 0, stagger: 0.2, ease: 'power2.out' }, '-=0.2')

            .set([this.audioNoticeEl, ...els], { clearProps: 'all' })
            .add(() => this.audioNoticeEl.classList.remove('show'))
        ;
    }
}